import { createIndexedDBSuperstore } from 'superstore';
let client;
export const getSuperstoreClient = () => {
  if (!client) {
    client = createIndexedDBSuperstore({
      namespace: 'global-search-ui'
    });
  }
  return client;
};
let connection;
export const getSuperstoreConnection = async () => {
  if (!connection) {
    connection = await getSuperstoreClient().open();
  }
  return connection;
};